// services/paymentService.js
import axios from 'axios';

export const paymentService = {
  async createCheckoutSession({ priceId, user, isPackage = false, sessionType = 'individual' }) {
    try {
      console.log(`Enviando requisição de checkout para ${isPackage ? 'pacote' : 'crédito'} do tipo: ${sessionType}`);
      
      // Determinar o endpoint correto com base no tipo de produto
      const endpoint = isPackage ? 'packages/checkout' : 'create-checkout-session';
      
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/${endpoint}`,
        JSON.stringify({
          priceId,
          user,
          sessionType // Adicionando o tipo de sessão à requisição
        }),
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Erro ao criar sessão de checkout:', error);
      throw error;
    }
  },
  
  // Método alternativo específico para créditos
  async createCreditCheckoutSession({ priceId, user, sessionType = 'individual' }) {
    try {
      console.log(`Enviando requisição de checkout para crédito do tipo: ${sessionType}`);
      
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/create-checkout-session`,
        JSON.stringify({
          priceId,
          user,
          sessionType
        }),
        {
          headers: { 'Content-Type': 'application/json' }
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Erro ao criar sessão de checkout para crédito:', error);
      throw error;
    }
  }
};